import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import {MainLayout} from "../../../layout/MainLayout";
import {
  GetLifestylePortfolioTemplates,
  Portfolio,
  PortfolioTemplates
} from "../../../services/PortfolioApi";
import useAuth from "../../login/AuthContext";
import {Tabs} from "../../../UI/Tabs";
import {TabList} from "../../../UI/TabList";
import {Tab} from "../../../UI/Tab";
import {TabPanel} from "../../../UI/TabPanel";
import { PortfolioDetailedReport } from "./PortfolioDetailedReport";
import {TemplateDisplay} from "../../../components/Templates/TemplateDisplay/TemplateDisplay";
import {useGetBreadcrumbs} from './sharedElements';
import { PortfolioIntegrationsTab } from "./PortfolioIntegrationsTab";
import { CommunitiesTab } from "./CommunitiesTab";

export const PortfolioDetailedView: React.FC = () => {
  const { getAuthToken } = useAuth();
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const [portfolio] = useState<Portfolio>();
  const [templates, setTemplates] = useState<PortfolioTemplates | undefined>(undefined);
  const endAdornment = useGetBreadcrumbs(portfolio);

  useEffect(() => {
    const load = async () => {
      let templatesRequest = await GetLifestylePortfolioTemplates(portfolioId, await getAuthToken());

      if (templatesRequest) {
        setTemplates(templatesRequest);
      }
    };
    load();
  }, [portfolioId]);


  if (!templates) {
    return <>
      Loading
    </>;
  }

  return (
    <MainLayout
      title="Portfolios"
      subtitle={portfolio?.name}
      endAdornment={portfolio ? endAdornment : null}
    >
      <Tabs id={"portfolioTabs"}>
        <TabList>
          <Tab>Networks</Tab>
          <Tab>Templates</Tab>
          <Tab>Reports</Tab>
          <Tab>Integrations</Tab>
        </TabList>
        <TabPanel>
          <CommunitiesTab portfolioId={portfolioId} />
        </TabPanel>
        <TabPanel>
          <TemplateTab templates={templates} portfolioId={portfolioId} />
        </TabPanel>
        <TabPanel>
          <PortfolioDetailedReport />
        </TabPanel>
        <TabPanel>
          <PortfolioIntegrationsTab portfolioId={portfolioId}/>
        </TabPanel>
      </Tabs>
    </MainLayout>
  );
};



interface TemplateTabProps {
  templates: PortfolioTemplates;
  portfolioId: string;
}

const TemplateTab: React.FC<TemplateTabProps> = ({ templates, portfolioId }) => {
  return <TemplateDisplay canCreate={true} templates={templates} portfolioId={portfolioId} />;

  // return <Table>
  //     <TableHead>
  //         <TableRow>
  //             <TableCell>Template</TableCell>
  //         </TableRow>
  //     </TableHead>
  //     {templates.map(template => <PortfolioTemplateRow key={template.id} portfolioId={portfolioId} template={template} />)}
  // </Table>;
};

// interface PortfolioTemplateRowProps {
//     portfolioId: string;
//     template: Partial<PortfolioTemplate>;
// }
//
// const PortfolioTemplateRow: React.FC<PortfolioTemplateRowProps> = ({portfolioId, template}) => {
//     const { push } = useHistory();
//
//     return <TableRow onClick={() => {push(PORTFOLIO_TEMPLATE_DETAILED.replace(":portfolioId", portfolioId).replace(":templateId", String(template.id)));}}>
//         <TableCell>{template.name}</TableCell>
//     </TableRow>;
// };


export const PORTFOLIO_DETAILED = "/super_admin/portfolios/:portfolioId";